import { useTranslation } from 'react-i18next'
import { ConfirmDialog } from '@/components/confirm-dialog'
import type { PrecursorCnCodeSourceGroupsPathTarget } from '@/features/installations/lib/precursor-cn-code-source-groups-path'

export type PendingSupplierInstallationDelete = {
  id: string
  label: string
  sourceGroupCount: number
  sourceGroupReferenceTarget: PrecursorCnCodeSourceGroupsPathTarget | null
}

type SupplierInstallationDeleteConfirmDialogProps = {
  pendingDelete: PendingSupplierInstallationDelete | null
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  isLoading?: boolean
}

export function SupplierInstallationDeleteConfirmDialog({
  pendingDelete,
  open,
  onOpenChange,
  onConfirm,
  isLoading = false,
}: SupplierInstallationDeleteConfirmDialogProps) {
  const { t } = useTranslation(['installations', 'common'])

  if (!pendingDelete) {
    return null
  }

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title={t('installations:suppliers.edit.installations.deleteConfirm.title')}
      desc={t('installations:suppliers.edit.installations.deleteConfirm.description', {
        label: pendingDelete.label,
      })}
      cancelBtnText={t('common:actions.cancel')}
      confirmText={t('common:actions.delete')}
      destructive
      isLoading={isLoading}
      handleConfirm={onConfirm}
    />
  )
}
